import { ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const globalSettingsIssuesTypesTranslationsRoute = {
	name: ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE,
	path: '/secure/admin/ViewTranslations!default.jspa',
	query: ['issueConstantType=issuetype'],
};
